module.exports = __webpack_public_path__ + "img/edgecontrol.a417ccbb.svg";